import {
  getMisDeptTreeRequest,
  getMisDeptPersonsRequest,
  getFlowRoleConfRequest,
  requestFlowRoleConf,
  getPersonPoolsRequest,
  getAutoActionConfRequest,
  requestModifyFlowRoleConf,

} from '../../../api/api'
import {getUrl} from "../../../utils/global/geturl";  // 导入封装后的axios请求

const state = {}

const getters = {}

const actions = {
  async getMisDeptTree ({commit}, params) {
    return getMisDeptTreeRequest(getUrl(params)).then(response => response)
  },
  async getMisDeptPersons ({commit}, params) {
    return getMisDeptPersonsRequest(getUrl(params)).then(response => response)
  },
  async getFlowRoleConf ({commit}, params) {
    return getFlowRoleConfRequest(getUrl(params)).then(response => response)
  },
  async flowRoleConfMethod ({commit}, params) {
    return requestFlowRoleConf(params).then(response => response)
  },
  async getPersonPools ({commit}, params) {
    return getPersonPoolsRequest(getUrl(params)).then(response => response)
  },

  async getAutoActionConf ({commit}, params) {
    return getAutoActionConfRequest(getUrl(params)).then(response => response)
  },
  async modifyFlowRoleConf ({commit}, params) {
    return requestModifyFlowRoleConf(params).then(response => response)
  },
};

const mutations = {}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/flowroleconf/flowroleconf.js